import {BaseService} from '../../../services/base.service';
import {environment} from "../../../environments/environment";
import {HttpParams} from "@angular/common/http";

export class ProductDataSet extends BaseService {

    params: DataSetParams[] = [];
    URL = '';
    page = 1;
    pageSize = 20;
    sortBy = 'created_at';
    sortDir = 'DESC';

    clearParams() {
        this.params = [];
    }

    pushParams(field: string, value: any, condition_type: string) {
        this.params.push(new DataSetParams(field, value, condition_type));
    }

    getDataSetParams(website_id) {

        if(this.params.length == 0)
        {
            return;
        }

        let parameters = new HttpParams();

        parameters = parameters.append("searchCriteria[filter_groups][0][filters][0][field]", "website_id");
        parameters = parameters.append("searchCriteria[filter_groups][0][filters][0][value]", website_id);
        parameters = parameters.append("searchCriteria[filter_groups][0][filters][0][condition_type]", 'eq');


        for (let i = 0; i < this.params.length; i++) {
            parameters = parameters.append("searchCriteria[filter_groups][0][filters][" + (i+1) + "][field]", this.params[i].field);
            parameters = parameters.append("searchCriteria[filter_groups][0][filters][" + (i+1) + "][value]", this.params[i].value);
            parameters = parameters.append("searchCriteria[filter_groups][0][filters][" + (i+1) + "][condition_type]", this.params[i].condition_type);
        }
        parameters = parameters.append("searchCriteria[filter_groups][1][filters][0][condition_type]", "eq")
        parameters = parameters.append("searchCriteria[filter_groups][1][filters][0][field]", "visibility")
        parameters = parameters.append("searchCriteria[filter_groups][1][filters][0][value]", 4)

        // this.URL = environment.baseAPI +`products?searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bfield%5D=${e.field}&searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bvalue%5D=${e.value}&searchCriteria[filterGroups][0][filters][0][conditionType]=${e.condition_type}&searchCriteria[currentPage]=${e.page}&searchCriteria[pageSize]=20`;
        parameters= parameters.append("searchCriteria[sortOrders][0][field]", this.sortBy);
        parameters= parameters.append("searchCriteria[sortOrders][0][direction]", this.sortDir);
        parameters = parameters.append("searchCriteria[pageSize]", this.pageSize);
        parameters = parameters.append("searchCriteria[currentPage]", this.page);




        return parameters;

    }

}

export class DataSetParams {
    field = '';
    value:any = null;
    condition_type = '';

    constructor(field: string, value: any, condition_type: string) {
        this.field = field;
        this.value = value;
        this.condition_type = condition_type;
    }
}
